<template>
  <div>
    <vs-popup :title="$t(popupTitle)" :active.sync="showModal">
      <form>
        <span>{{ $t("AccountSubsidiaryTitle") }}</span>
        <v-select
          label="title"
          :options="parentType"
          v-model="model.connectedAccounts"
          :reduce="(x) => x.id"
          :clearable="false"
          :multiple="true"
          ref="agentType"
          dir="rtl"
        >
        </v-select>
        <div class="mb-10" v-if="model.id == null">
          <vs-select
            :label="$t('AccountReferenceType')"
            v-model="model.accountReferenceType"
            name="AccountReferenceType"
            class="w-full mt-5"
            v-validate="'required'"
          >
            <vs-select-item class="w-full" :value="3" text="طرف تجاری" />
            <vs-select-item class="w-full" :value="2" text="بانک" />
          </vs-select>
          <span
            class="text-danger text-sm"
            v-show="errors.has('AccountReferenceType')"
            >{{ errors.first("AccountReferenceType") }}</span
          >
          <vs-input
            class="inputx mb-4 mt-3"
            v-model="model.accountReferenceId"
            name="AccountReferenceId"
            :label="$t('AccountReferenceId')"
            v-validate="'required'"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('AccountReferenceId')"
            >{{ errors.first("AccountReferenceId") }}</span
          >
          <vs-input
            class="inputx mb-4 mt-1"
            v-model="model.title"
            name="AccountFloatingTitle"
            :label="$t('AccountFloatingTitle')"
            v-validate="'required'"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('AccountFloatingTitle')"
            >{{ errors.first("AccountFloatingTitle") }}</span
          >
          <div>
            <label class="vs-select--label datepicker-lb">{{
              $t("StartClock")
            }}</label>
            <date-picker
              v-model="model.startClock"
              type="datetime"
              format="jYYYY-jMM-jDD HH:mm:ss"
              display-format="jYYYY-jMM-jDD HH:mm:ss"
              class="date-picker"
              name="StartClock"
              v-validate="'required'"
              :label="$t('StartClock')"
              :clearable="true"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('StartClock')"
              >{{ errors.first("StartClock") }}</span
            >
          </div>
          <div class="mt-4">
            <label class="vs-select--label datepicker-lb">{{
              $t("ExpireClock")
            }}</label>
            <date-picker
              v-model="model.expireClock"
              type="datetime"
              format="jYYYY-jMM-jDD HH:mm:ss"
              display-format="jYYYY-jMM-jDD HH:mm:ss"
              class="date-picker"
              name="ExpireClock"
              v-validate="'required'"
              :label="$t('ExpireClock')"
              :clearable="true"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('ExpireClock')"
              >{{ errors.first("ExpireClock") }}</span
            >
          </div>
          <vs-textarea
            rows="5"
            class="mt-4"
            name="Description"
            :label="$t('Description')"
            v-model="model.description"
          />
        </div>


        <vs-button
        v-if="model.id != null"
          type="filled"
          class="float-right mb-4 mt-12"
          @click.prevent="submitForm"
          >{{ $t("Save") }}</vs-button
        >
        <vs-button
        v-else
          type="filled"
          class="float-right mb-4"
          :class="model.id != null ? 'mt-12' : ''"
          @click.prevent="submitForm"
          :disabled="
            !model.expireClock ||
            !model.startClock ||
            !model.title ||
            !model.accountReferenceId ||
            !model.accountReferenceType ||
            !model.connectedAccounts
          "
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";
import vSelect from "@/components/CustomVSelect.vue";

const dict = {
  custom: {
    AccountFloatingTitle: {
      required: "لطفا عنوان حساب شناوری را وارد نمایید.",
    },
    AccountSubsidiaryTitle: {
      required: "لطفا عنوان حساب معین را وارد نمایید.",
    },
  
    StartClock: {
      required: "لطفا تاریخ شروع را وارد نمایید.",
    },
    ExpireClock: {
      required: "لطفا تاریخ انقضا را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  components: {
    "v-select": vSelect,
  },
  props: {
    show: { default: false },
    model: {
      default: {},
    },
    parentType: {
      default: [],
    },
  },
  data() {
    return {
      AccountTitle: "",
      popupTitle: "",
      disabled: false,
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createAccount: "floatingAccount/create",
      updateAccount: "floatingAccount/update",
    }),
    submitForm() {
      this.$validator.validateAll().then((result) => {
        this.disabled = true;
        if (result) {
          if (this.model.id != null) {
            this.model = {
              accountId: this.model.id,
              connectedAccounts: this.model.connectedAccounts,
            };
            this.updateAccount(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
              this.disabled = false;
            });
            
          } else {
            this.createAccount(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
              this.disabled = false;
            });
          }
        } else {
          // form have errors
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        this.disabled = false;

        if (this.model.id) this.popupTitle = "EditFloatingAccount";
        else this.popupTitle = "CreateNewFloatingAccount";
      }
      this.$validator.reset();
    },
  },
};
</script>
